import {
  LayoutDashboard, Users, FolderKanban, Stethoscope, ClipboardList, FileSearch,
  Activity, ClipboardCheck, Boxes, FileText, FolderOpen, CalendarDays,
  BellRing, UsersRound, Sparkles, GraduationCap, ShieldCheck, CreditCard,
} from "lucide-react";

export const NAV_SECTIONS = [
  {
    label: "Workspace",
    items: [
      { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true },
      { to: "/patients", label: "Patients", icon: Users },
      { to: "/cases", label: "Cases", icon: FolderKanban },
      { to: "/consultations", label: "Consultations", icon: Stethoscope },
    ],
  },
  {
    label: "Clinical",
    items: [
      { to: "/forms", label: "Clinical Forms", icon: ClipboardList },
      { to: "/treatment-plans", label: "Treatment Plans", icon: ClipboardCheck },
      { to: "/reports", label: "Clinical Reports", icon: FileText },
      { to: "/education", label: "Patient Education", icon: GraduationCap },
      { to: "/documents", label: "Documents", icon: FolderOpen },
    ],
  },
  {
    label: "Practice",
    items: [
      { to: "/appointments", label: "Appointments", icon: CalendarDays },
      { to: "/follow-ups", label: "Follow-ups", icon: BellRing },
      { to: "/team", label: "Team", icon: UsersRound },
      { to: "/billing", label: "Consultation credits", icon: CreditCard },
    ],
  },
  {
    label: "Intelligence",
    items: [
      { to: "/ai", label: "CONTAHA AI", icon: Sparkles },
    ],
  },
  {
    label: "Management",
    items: [
      { to: "/admin", label: "Admin Panel", icon: ShieldCheck, adminOnly: true },
      { to: "/plans", label: "Plans & Pricing", icon: CreditCard },
    ],
  },
];
